module.exports = __webpack_public_path__ + "img/375_news_main_img3.c9611212.png";